import { Routes, Route } from "react-router-dom";
import { Login } from "../pages/auth/login";

import { RecoverPassword } from "../pages/auth/recoverPassword";
import { ChangePasswordFT } from "../pages/auth/changePasswordFT";
import { ValidateCredentials } from "../pages/auth/validateCredentials";
import ProtectedRoute from "./protectedRoutes";
import { AdminHome } from "../pages/admin/home";

import Layout from "../components/layout/layout";
import { ListUsers } from "../pages/admin/listUsers";
import { UserDetail } from "../pages/admin/userDetail";
import { ListMenuOptions } from "../pages/admin/listMenuOptions";
import NotFound from "../pages/common/notfound";
import { ListRoles } from "../pages/admin/listRoles";
import { LoadingPage } from "../pages/common/loading";
import AdminCompanies from "../pages/admin/adminCompanies";
import ManageBusinessGroup from "../pages/admin/manageBusinessGroup/manageBusinessGroup";
import AdminGeographies from "../pages/admin/geographies/adminGeographies";
import CreateGeography from "../pages/admin/geographies/CRUD/createGeography";

import { InfonavitHome } from "../pages/user/index";

import { UploadEmployees } from "../pages/user/uploadEmployees";

import AdminUsers from "../pages/user/configuration/adminUsers";
import { AdminCredentials } from "../pages/user/configuration/adminCredentials";
import { AdminNRPs } from "../pages/user/configuration/adminNRPs";

import DynamicReport from "../pages/user/dynamicReport";

import { AdminAutomaticRequests } from "../pages/user/configuration/adminAutomaticRequests";

import { InfonavitRequests } from "../pages/user/infonavitRequests";
import { InfonavitLocalRequests } from "../pages/user/infonavitLocalRequests";

function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Login />} />

      <Route path="/recoverPassword" element={<RecoverPassword />} />
      <Route path="/changePasswordFT" element={<ChangePasswordFT />} />

      <Route
        path="/validateCredentials/email/:email"
        element={<ValidateCredentials />}
      />

      {/* Admin Routes */}

      <Route element={<ProtectedRoute requiredRole={"admin"} />}>
        <Route path="admin" element={<Layout />}>
          <Route path="home" element={<AdminHome />} />

          <Route path="listUsers" element={<ListUsers />} />
          <Route
            path="listUsers/:country/:companyId"
            element={<UserDetail />}
          />
          <Route path="listMenuOptions" element={<ListMenuOptions />} />
          <Route path="listRoles" element={<ListRoles />} />
          <Route path="adminGeographies" element={<AdminGeographies />} />
          <Route path="uploadGeography" element={<CreateGeography />} />
          <Route path="adminCompanies" element={<AdminCompanies />} />
          <Route path="manageBusinessGroup" element={<ManageBusinessGroup />} />
        </Route>
      </Route>

      {/* Infonavit -> Configuration */}
      <Route element={<ProtectedRoute requiredRole={"user"} path="home" />}>
        <Route path="user/configuration" element={<Layout />}>
          <Route path="consult" element={<AdminAutomaticRequests />} />
          <Route path="users" element={<AdminUsers />} />
          <Route path="credentials" element={<AdminCredentials />} />
          <Route path="credentials/:rfc" element={<AdminNRPs />} />
        </Route>
      </Route>

      {/* Infonavit -> Dynamic Report */}
      <Route element={<ProtectedRoute requiredRole={"user"} path="home" />}>
        <Route path="user/reports" element={<Layout />}>
          <Route path="dynamic" element={<DynamicReport />} />
        </Route>
      </Route>

      {/* Infonavit -> Requests */}
      <Route element={<ProtectedRoute requiredRole={"user"} path="home" />}>
        <Route path="user/infonavit" element={<Layout />}>
          <Route path="request" element={<InfonavitRequests />} />
          <Route path="request/local" element={<InfonavitLocalRequests />} />
        </Route>
      </Route>

      {/* Infonavit -> Upload employees */}
      <Route element={<ProtectedRoute requiredRole={"user"} path="home" />}>
        <Route path="user/upload" element={<Layout />}>
          <Route path="employees" element={<UploadEmployees />} />
        </Route>
      </Route>

      {/* User Route home */}
      <Route element={<ProtectedRoute requiredRole={"user"} path="home" />}>
        <Route path="user" element={<Layout />}>
          <Route path="home" element={<InfonavitHome />} />
        </Route>
      </Route>

      {/* User Route listUsers */}

      <Route
        element={<ProtectedRoute requiredRole={"user"} path="listUsers" />}
      >
        <Route path="user" element={<Layout />}>
          <Route path="listUsers" element={<ListUsers />} />
          <Route
            path="listUsers/:country/:companyId"
            element={<UserDetail />}
          />
        </Route>
      </Route>

      {/* Not Found */}

      <Route path="*" element={<NotFound />} />

      {/* Loading page */}

      <Route path="/loading" element={<LoadingPage />} />
    </Routes>
  );
}
export default AppRoutes;
